import { PostingSummary as PostingSummaryType } from "@/lib/types";
import { formatDate, joinWithAmpersand } from "@/lib/utils";

interface Props {
  posting: PostingSummaryType;
  totalMatches: number;
}

export default function PostingSummary({ posting, totalMatches }: Props) {
  const schoolDisplay = posting.area
    ? `${posting.schoolName} | ${posting.area}`
    : posting.schoolName;

  return (
    <div>
      <h1 className="text-2xl font-bold text-gray-900 mb-1">Hi there!</h1>
      <p className="text-gray-700">
        We found <span className="font-semibold underline">{totalMatches}</span>{" "}
        suitable applicants for your role:
      </p>
      <p className="font-semibold text-gray-900 mt-2">{schoolDisplay}</p>
      <p className="text-gray-600 text-sm">
        {joinWithAmpersand(posting.subjects)} |{" "}
        {joinWithAmpersand(posting.levels)} | {formatDate(posting.startDate)} -{" "}
        {formatDate(posting.endDate)}
      </p>
    </div>
  );
}
